import React from 'react';
import { Mail, Phone, MapPin, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const footerLinks = {
    produk: [
      { name: 'XAI Dashboard', href: '#' },
      { name: 'Mobile Apps', href: '#' },
      { name: 'WhatsApp Integration', href: '#' },
      { name: 'API Documentation', href: '#' }
    ],
    solusi: [
      { name: 'Untuk UMKM', href: '#' },
      { name: 'Untuk Enterprise', href: '#' },
      { name: 'Accounting System', href: '#' },
      { name: 'ERP Solutions', href: '#' }
    ],
    dukungan: [
      { name: 'Video Tutorial', href: '/demo' },
      { name: 'Contact Support', href: 'whatsapp', whatsapp: true }
    ],
    perusahaan: [
      { name: 'Tentang BTSSOFT', href: '#' },
      { name: 'Tim Kami', href: '#' },
      { name: 'Karir', href: '#' },
      { name: 'Blog', href: '#' }
    ]
  };

  return (
    <footer className="bg-black text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_139a1b8f-e7a3-436b-b3e2-334218a84ff2/artifacts/ujujlmbw_Logo%20BTSSOFT%20Realistic%202025.09.png" 
                alt="BTSSOFT" 
                className="h-10 w-auto"
              />
              <div>
                <h3 className="font-bold text-xl">{companyInfo.name}</h3>
                <p className="text-gray-400 text-sm">Software Developer</p>
              </div>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              {companyInfo.description}. Menghadirkan solusi ERP dan sistem akuntansi 
              terdepan untuk UMKM Indonesia.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Mail className="h-4 w-4 text-blue-400" />
                <span className="text-gray-400">{companyInfo.email}</span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-4 w-4 text-green-400" />
                <span className="text-gray-400">{companyInfo.phone}</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin className="h-4 w-4 text-red-400" />
                <span className="text-gray-400">{companyInfo.address}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Produk</h4>
            <ul className="space-y-3">
              {footerLinks.produk.map((link) => (
                <li key={link.name}>
                  <a 
                    href={link.href}
                    className="text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-6">Solusi</h4>
            <ul className="space-y-3">
              {footerLinks.solusi.map((link) => (
                <li key={link.name}>
                  <a 
                    href={link.href}
                    className="text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-6">Dukungan</h4>
            <ul className="space-y-3">
              {footerLinks.dukungan.map((link) => (
                <li key={link.name}>
                  {link.whatsapp ? (
                    <button
                      onClick={() => window.open('https://api.whatsapp.com/send/?phone=6281218691110&text=Halo%20BTSSOFT%2C%20saya%20membutuhkan%20support%20untuk%20XAI%20ERP%20System.&type=phone_number&app_absent=0', '_blank')}
                      className="text-gray-400 hover:text-white transition-colors duration-200 text-left"
                    >
                      {link.name}
                    </button>
                  ) : link.href.startsWith('/') ? (
                    <Link
                      to={link.href}
                      className="text-gray-400 hover:text-white transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  ) : (
                    <a 
                      href={link.href}
                      className="text-gray-400 hover:text-white transition-colors duration-200"
                    >
                      {link.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © 2025 {companyInfo.name}. All rights reserved. Specialized ERP Solutions for Indonesian UMKM.
            </div>
            
            {/* Social Links */}
            <div className="flex items-center space-x-6">
              <span className="text-gray-400 text-sm">Follow us:</span>
              <a href={companyInfo.social.instagram} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-400 transition-colors duration-200">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;